import React from "react";
import { Box, Toolbar } from "@mui/material";
import TopBar from "./AppBar";
import Sidebar from "./Sidebar";

const MainLayout = ({ children }) => (
  <Box sx={{ display: "flex" }}>
    <TopBar />
    <Sidebar />
    <Box component="main" sx={{ flexGrow: 1, p: 3, mx: 14 }}>
      <Toolbar />
      {children}
    </Box>
  </Box>
);

export default MainLayout;
